import {
    FormLabel,
    Grid,
    IconButton,
    InputAdornment,
    Paper,
    TextField,
    Typography } from "../../ui";
import RemoveIcon from '../../ui/icons/Remove';
import AddIcon from '../../ui/icons/Add';
import PriceTag from "../../global/PriceTag";
import uiUtilInstance from "../../../utilities/uiUtil";
import {
  isEmpty
} from "../../../constants/constant";

const RenderComboDialog = ({ mComboDetails, mStockInfos, itemQuantity, setItemQuantity }) => {

    const colQuantityClasses = uiUtilInstance.useStyles();

    const handleColQuantityChange = (event) => {
        const value = event.target.value;
        const regex = /^[0-9]*$/;
        if (regex.test(value)) {
            const parsedValue = Number(value) || 1;
            setItemQuantity(parsedValue);
        }
    };

    const handleIncrement = () => {
        setItemQuantity(prev => Number(prev) + 1);
    };

    const handleDecrement = () => {
        setItemQuantity(prev => (prev > 1 ? Number(prev) - 1 : 1));
    };

    const getProductDetailsUI = () => {
        return (
            <Paper elevation={10}
                autoHeight
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    backgroundColor: "#9db5ab",
                    boxShadow: 1,
                    borderRadius: 4,
                    padding: 2,
                }} >
                <div>
                    <Typography
                        variant="p"
                        style={{ fontSize: "14px" }}
                        component="div">
                        <span style={{ color: "blue", fontWeight: "bold" }}>Item Name</span>
                        <span style={{ margin: "0 4px" }}>:</span>
                        <span style={{ color: "green", fontFamily: "monospace", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{mComboDetails.name}</span>
                    </Typography>
                    <PriceTag price={Number(mComboDetails.price) || 0.0} finalPrice={Number(mComboDetails.subTotalPrice) || 0.0}
                        offerAmt={Number(mComboDetails.appliedOfferAmt) || 0.0} />
                    {/* <span style={{
                        color: "green", fontFamily: "monospace", whiteSpace: 'pre-wrap',
                        overflowWrap: 'break-word'
                    }}>{" per " + mComboDetails.unit}</span> */}
                    <div style={{ marginTop: "5px" }}>
                        <FormLabel component="legend"><span style={{ color: "blue", fontWeight: "bold" }}>Enter Quantity:</span></FormLabel>
                        <TextField
                            id="dialogQuan"
                            className={colQuantityClasses.input}
                            name="dialogQuan"
                            variant="outlined"
                            size="small"
                            value={itemQuantity}
                            style={{ width: "50%", maxHeight: "20%" }}
                            sx={{
                                justifyContent: "center", alignContent: "center",
                                '& .UiInputBase-input': {
                                    textAlign: "center",
                                },
                            }}
                            onChange={handleColQuantityChange}
                            InputProps={{
                                inputMode: "decimal",
                                startAdornment: (
                                    <InputAdornment
                                        position="start"
                                    >
                                        <IconButton onClick={handleIncrement}
                                            sx={{ backgroundColor: "green", padding: 0, "&:hover": { backgroundColor: "darkgreen" } }}>
                                            <AddIcon sx={{ color: "white", fontSize: "2rem" }} />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment
                                        position="end"
                                    >
                                        <IconButton onClick={handleDecrement}
                                            sx={{ backgroundColor: "red", padding: 0, "&:hover": { backgroundColor: "darkred" } }}>
                                            <RemoveIcon sx={{ color: "white", fontSize: "2rem" }} />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </div>
                </div>
            </Paper>
        );
    };

    const getStockDetailsUI = (index, info) => {
        return (
            <Paper elevation={10} key={index}
                autoHeight
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    backgroundColor: "#c0d6e4",
                    boxShadow: 1,
                    borderRadius: 4,
                    padding: 2,
                    margin:"2px"
                }} >
                <Grid container spacing={1} key={index}>
                    <Grid item xs={6}>
                        <Typography
                            variant="p"
                            style={{
                                color: "#480404",
                                fontWeight: "bold",
                                fontSize: "14px", whiteSpace: 'pre-wrap',
                                overflowWrap: 'break-word'
                            }}>{`${info.name}(${info.stockName})`}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography
                            variant="p"
                            style={{
                                fontSize: "14px", whiteSpace: 'pre-wrap',
                                overflowWrap: 'break-word'
                            }}>Quan: {`${info.itemCount} ${info.unitName}`}
                        </Typography>
                    </Grid>
                    <Grid item xs={isEmpty(info.batchNo) ? 12 : 6}>
                        <Typography
                            variant="p"
                            style={{
                                color: "#480404",
                                fontSize: "14px", whiteSpace: 'pre-wrap',
                                overflowWrap: 'break-word'
                            }}>BarCode: {info.barCode}
                        </Typography>
                    </Grid>
                    <Grid item xs={isEmpty(info.barCode) ? 12 : 6}>
                        <Typography
                            variant="p"
                            style={{
                                color: "#480404",
                                fontSize: "14px", whiteSpace: 'pre-wrap',
                                overflowWrap: 'break-word'
                            }}>BatchNum: {info.batchNo}
                        </Typography>
                    </Grid>
                </Grid>
            </Paper>
        );
    }

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                {getProductDetailsUI()}
            </Grid>
            {
                mStockInfos && mStockInfos.map((info, index) => (
                    <Grid item xs={12} md={6} sm={6} lg={6}>
                        {getStockDetailsUI(index, info)}
                    </Grid>
                ))
            }
        </Grid>
    )
};

export default RenderComboDialog;